"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _propTypes = _interopRequireDefault(require("prop-types"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    primary: {
      margin: theme.spacing(0.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white,
      "&:hover": {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.8)
      },
      "&:disabled": {
        color: theme.palette.white,
        backgroundColor: theme.palette.disabled
      }
    },
    secondary: {
      margin: theme.spacing(0.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      textTransform: "none",
      border: "solid 1px",
      backgroundColor: "rgba(255,255,255,0)",
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.light, 0.1),
        color: theme.palette.primary.main
      }
    },
    tertiary: {
      margin: theme.spacing(0.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      textTransform: "none",
      backgroundColor: "rgba(255,255,255,0)",
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0)",
        color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.8)
      }
    }
  };
});

var DynamicButton = function DynamicButton(_ref) {
  var type = _ref.type,
      addIcon = _ref.addIcon,
      onWhichSide = _ref.onWhichSide,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["type", "addIcon", "onWhichSide", "children"]);
  var classes = useStyles();
  var side = "".concat(onWhichSide) + "Icon";
  var iconProps = (0, _defineProperty2["default"])({}, side, addIcon);
  return /*#__PURE__*/_react["default"].createElement(_core.Button, (0, _extends2["default"])({
    className: classes[type],
    disableRipple: true,
    disableElevation: true
  }, iconProps, rest), children);
};

DynamicButton.propTypes = {
  type: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  addIcon: _propTypes["default"].node,
  onWhichSide: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  size: _propTypes["default"].string,
  children: _propTypes["default"].node
};
DynamicButton.defaultProps = {
  type: "primary",
  disabled: false,
  addIcon: null,
  onWhichSide: "start",
  size: "medium",
  children: "Call to action",
  onClick: function onClick() {
    return alert('this is a default onClick message.');
  }
};
var _default = DynamicButton;
exports["default"] = _default;